(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rentree-slideshow"] && !Shopify.designMode) return;
  try {
    
  class RentreeSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.rentree-slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('.rentree-slideshow__dot'));
      this.prevBtn = this.querySelector('.rentree-slideshow__arrow--prev');
      this.nextBtn = this.querySelector('.rentree-slideshow__arrow--next');
      this.viewport = this.querySelector('.rentree-slideshow__viewport');
      this.index = 0;
      this.autoplayDelay = (parseFloat(this.dataset.autoplay) || 5) * 1000;
      this.timer = null;
      this.resumeTimer = null;

      if (this.slides.length <= 1) return;

      this.prevBtn?.addEventListener('click', () => {
        this.go(this.index - 1);
        this.pauseThenResume();
      });
      this.nextBtn?.addEventListener('click', () => {
        this.go(this.index + 1);
        this.pauseThenResume();
      });
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.go(i);
          this.pauseThenResume();
        });
      });

      let startX = 0;
      let deltaX = 0;
      let dragging = false;

      this.viewport.addEventListener(
        'touchstart',
        (e) => {
          dragging = true;
          startX = e.touches[0].clientX;
          deltaX = 0;
          this.pause();
        },
        { passive: true }
      );

      this.viewport.addEventListener(
        'touchmove',
        (e) => {
          if (!dragging) return;
          deltaX = e.touches[0].clientX - startX;
        },
        { passive: true }
      );

      this.viewport.addEventListener('touchend', () => {
        if (!dragging) return;
        dragging = false;
        if (Math.abs(deltaX) > 40) {
          if (deltaX < 0) {
            this.go(this.index + 1);
          } else {
            this.go(this.index - 1);
          }
        }
        this.pauseThenResume();
      });

      this.viewport.addEventListener('mouseenter', () => this.pause());
      this.viewport.addEventListener('mouseleave', () => this.resume());
      this.viewport.addEventListener('focusin', () => this.pause());
      this.viewport.addEventListener('focusout', () => this.resume());

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.resume();
              } else {
                this.pause();
              }
            });
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      } else {
        this.resume();
      }
    }

    go(i) {
      const count = this.slides.length;
      this.index = (i + count) % count;
      this.slides.forEach((slide, idx) => {
        const active = idx === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, idx) => {
        const active = idx === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    pause() {
      clearInterval(this.timer);
      this.timer = null;
      clearTimeout(this.resumeTimer);
    }

    resume() {
      if (this.timer || this.slides.length <= 1) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.autoplayDelay);
    }

    pauseThenResume() {
      this.pause();
      this.resumeTimer = setTimeout(() => this.resume(), this.autoplayDelay);
    }

    disconnectedCallback() {
      this.pause();
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('rentree-slideshow')) {
    customElements.define('rentree-slideshow', RentreeSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
